import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const Other = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    sleepHabit: "",
    music: "",
    hobby: "",
    contactLike: "",
    religionDescription: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const validate = Yup.object({
    sleepHabit: Yup.string().nullable(),
    music: Yup.string().nullable(),
    hobby: Yup.string().nullable(),
    contactLike: Yup.string().nullable(),
    religionDescription: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, careDirectiveId, otherCareDirectiveId, ...rest } =
      values;
    const payload = {
      ...data,
      otherCareDirective: {
        ...rest,
        careDirectiveId,
        otherCareDirectiveId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, uID);
    if (result?.success) {
      // toast.success(t(getKeyFromText(result?.message)));
      next();
    }
    setButtonDisabled(false);
  };

  const handleSkipFun = async () => {
    next();
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const getCareDirectiveDataFun = async () => {
    setIsLoading(true);
    setButtonDisabled(true);
    try {
      const result = await getCareDirectiveData(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad.otherCareDirective !== null) {
          setInitialValues(result.payLoad.otherCareDirective);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <Typography>{t("cd-tab-4")}</Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-o-text-1")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="sleepHabit"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-o-text-2")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="music"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-o-text-3")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="hobby"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-o-text-4")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="contactLike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-o-text-5")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="religionDescription"
                    type="text"
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default Other;
